
//import myWorker from "./test.worker";
import { CalculatePriceAction, CalculatePriceReserveAction } from "../../../Redux/actions/actions";
import { SetPriceNewOrder } from "../../../Redux/actions/actionNames";
 
 
const myWorker =  new URL('./test.worker', import.meta.url) 
export const CalculatePriceReserveWorker = (data, dispatch, noHttpOrder) => {
  const worker = new Worker(myWorker);
  worker.postMessage(JSON.stringify(data))
  worker.addEventListener("message", (event) => {

    if (event.data.succeessfull) {
      if (noHttpOrder) {
        dispatch(SetPriceNewOrder({}, { done: true }));
      } else {
        dispatch(CalculatePriceReserveAction(dispatch, event.data.data));
      }
    } else {
      dispatch(SetPriceNewOrder({ done: false }, { done: false ,where:"204" }));
    }
    worker.terminate();
  });
};
